import { Instruction } from 'src/components/instruction';

export const InstructionPage = () => <Instruction />;
